import { render } from "./PhonePart9.vue?vue&type=template&id=7a9a8a1f&scoped=true"
import script from "./PhonePart9.vue?vue&type=script&lang=js"
export * from "./PhonePart9.vue?vue&type=script&lang=js"

import "./PhonePart9.vue?vue&type=style&index=0&id=7a9a8a1f&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a9a8a1f"]])

export default __exports__